import { Injectable } from '@angular/core'
import { Chat, ChatP } from './chat.model';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class ChatService {
    private readonly urlBase = '/api/';
    private subject = new Subject<any>();

    constructor (private httpClient: HttpClient) {}

    getChats(id: number): Observable<ChatP[]> {
        return this.httpClient.get<ChatP[]>(this.urlBase + 'getChats?id=' + id);
    }

    getChatMessages(chat: ChatP): Observable<ChatP[]> {
        return this.httpClient.get<ChatP[]>(this.urlBase + 'getChatMessages?from=' + chat.from.id + '&to=' + chat.to.id);
    }

    save(chat: ChatP): Observable<number> {
        return this.httpClient.post<number>(this.urlBase + 'saveChatMessage', chat);
    }

    markAsSeen(chat: any) {
        return this.httpClient.post(this.urlBase + 'markAsSeen', chat);
    }

    onOpenedChat(): Observable<any> {
        return this.subject.asObservable();
    }

      openedChat(data: any = null) {
        this.subject.next(data);
    }
    unlockConsole()
    {
        
    }
}

